export interface ApiResponse<T> {
  data: T;
}

export interface GatewayResponse<T> {
  accessToken: string;
  data: T;
}

export interface Page<T> {
  pageable: Pageable;
  content: T[];
  totalPages: number;
  totalElements: number;
  size: number;
  first: boolean;
  last: boolean;
  empty: boolean;
  numberOfElements: number;
  number: number;
  sort: PageableSort;
}

export interface Pageable {
  sort: PageableSort;
  offset: number;
  pageSize: number;
  pageNumber: number;
  paged: boolean;
  unpaged: boolean;
}

export interface SelectedOption {
  label: string;
  value: string;
}

export interface PageableSort {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
}

export interface PageRequest {
  page?: number;
  size?: number;
  sortField?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export enum RevisionType {
  MOD = 'MOD',
  ADD = 'ADD',
  DEL = 'DEL'
}

export interface RevisionModel {
  revisionNumber: number;
  id?: string;
  revisionType: RevisionType;
  modifiedAt: string;
  modifiedBy: string;
  fieldName: string;
  fieldValue: string;
}

export enum StatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED'
}

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const MONTH_YEAR_FORMAT = 'MMMM YYYY';

export interface ConflictErrorModel {
  entity: string;
  name: string;
  criteria: {field: string, value: string}[];
}

export enum StatusCode {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  INVALID_PERMISSIONS = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  SESSION_EXPIRED = 406,
  INTERNAL_ERROR = 500
}

export interface BadRequestErrorModel {
  type: string;
  rows: ValidationErrorRow[];
}

export interface ValidationErrorRow {
  field: string;
  message: string;
  reason: string;
}

export class EntityError {
  entity: string;

  message: string;

  constructor(message: string, entity: string) {
    this.message = message;
    this.entity = entity;
  }
}

export const FILTER_DATE_FORMAT = 'YYYY-MM-DD';

export const FILTER_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const defaultPageSize = 100;

export interface IdentifierNameModel<T> {
  identifier: T;
  name: string;
}
